module.exports = __webpack_public_path__ + "img/logo.316eea4b.jpg";